module.exports = __webpack_public_path__ + "img/conifer-access-denied.1454ae81.png";